import { render, staticRenderFns } from "./HeadquarterGeneralData.vue?vue&type=template&id=679c88d1&"
import script from "./HeadquarterGeneralData.vue?vue&type=script&lang=ts&"
export * from "./HeadquarterGeneralData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports